import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between w-100" }
const _hoisted_2 = { class: "font-16" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex ga-1"
}
const _hoisted_4 = { class: "font-14" }
const _hoisted_5 = { class: "font-14 font-grey-dark" }
const _hoisted_6 = { class: "font-14" }
const _hoisted_7 = { class: "d-flex ga-1" }
const _hoisted_8 = { class: "font-14" }
const _hoisted_9 = { class: "font-14" }
const _hoisted_10 = { class: "text-right mt-3" }

import {computed, ref} from "vue";
import {useRouter} from "vue-router";
import {convertDateCalendar} from "@/components/Helpers/DateHelper";
import EventsAndActivityPanelCard
  from "@/components/Layout/LayoutV2/EventsAndActivityPanel/EventsAndActivityPanelCard.vue";
import Icon from "@/components/Icons/Icon.vue";
import EventDetailsModal from "@/components/Layout/LayoutV2/EventsAndActivityPanel/Cards/EventDetailsModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsActivity',
  props: {
  event: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  setup(__props) {

const router = useRouter();

const props = __props

const showEventDetailsModal = ref(false);

const getOrderId = computed(() => {
  return props.event.model.consultation.order_id ?? null
})

const getClinicServiceNameFromPackage = computed(() => {

  if (props.event.model.consultation.package_id !== null) {
    return {
      serviceName: props.event.model.clinic_service.name,
      packageName: props.event.model.consultation.name
    } ?? {}
  }

  return {}
})

const onShowEventModal = () => {
  showEventDetailsModal.value = !showEventDetailsModal.value;
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(EventsAndActivityPanelCard, null, {
    customContent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "ml-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'order-view', params: { id: getOrderId.value } })))
        }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(__props.event.name), 1),
          (getClinicServiceNameFromPackage.value.packageName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(getClinicServiceNameFromPackage.value.serviceName), 1),
                _createElementVNode("p", _hoisted_5, "(" + _toDisplayString(getClinicServiceNameFromPackage.value.packageName) + ")", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(convertDateCalendar)(__props.event.start_date)), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, "(" + _toDisplayString(__props.event.duration ?? '30 minutes') + ")", 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(__props.event.model?.method), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_btn, {
            class: "b-round-20 outline-btn white-btn mb-2",
            elevation: "0",
            height: "32px",
            variant: "outlined",
            width: "82px",
            "x-small": "",
            onClick: onShowEventModal
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("span", { class: "mr-1" }, "Info", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      (showEventDetailsModal.value)
        ? (_openBlock(), _createBlock(EventDetailsModal, {
            key: 0,
            modelValue: showEventDetailsModal.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showEventDetailsModal).value = $event)),
            event: __props.event
          }, null, 8, ["modelValue", "event"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})